import {Box, Typography} from '@mui/material';
import PersonalizeSearch from './PersonalizeSearch';
import type {PersonalizeSearchType} from './PersonalizeSearch';

type PersonalizeHeaderType = PersonalizeSearchType & {
  isMobile: boolean;
};
const PersonalizeHeader = ({
  isMobile,
  searchValue,
  onFilterChange,
}: PersonalizeHeaderType) => {
  return (
    <>
      <Typography
        variant={'body1'}
        fontStyle={'italic'}
        color={'primary'}
        fontSize={{xxs: 14, lg: 16}}
      >
        Get Started!
      </Typography>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Typography
          fontSize={{xxs: 14, md: 18, lg: 20}}
          fontWeight={500}
          lineHeight={1}
        >
          Create your own jobfeed
        </Typography>
        {onFilterChange && (
          <PersonalizeSearch
            searchValue={searchValue}
            onFilterChange={onFilterChange}
          />
        )}
      </Box>
      <Typography
        variant="body2"
        color={'text.secondary'}
        fontSize={{xxs: 12, lg: 14}}
        lineHeight={{xxs: 1.8, md: 0.5}}
      >
        {isMobile
          ? 'Click on any category to select tags'
          : 'Select tags to see jobs that fit your skills and interests'}
      </Typography>
    </>
  );
};

export default PersonalizeHeader;
